export default __webpack_public_path__ + "static/media/Sites.9293d6fd.png";